const en_US = {
	// Modal buttons
	ok: "OK",
	cancel: "Cancel",
	continue: "Continue",

	// Modal contents
	video_session: "Your account is in use on too many devices.",
	video_unsupported: `This video cannot be played on your device. Click <a href="https://neulion-a.akamaihd.net/nlweb/h5support/player.html" target="_blank">HERE</a> for more help.`,
	video_ad_blocked: "If you do have an ad blocker enabled, we request that you disable it on your browser before attempting to watch the content.",

};

// TODO
const pt_PT = {
	// Modal buttons
	ok: "Fechar",
	cancel: "Cancelar",
	continue: "Continuar",

	// Modal contents
	video_unsupported: `Este vídeo não pode ser reproduzido no seu dispositivo. <a href="https://neulion-a.akamaihd.net/nlweb/h5support/player.html" target="_blank">Saiba mais aqui</a>.`,

};

// TODO
const zh_TW = {
	// Modal buttons
	ok: "確定",
	cancel: "取消",
	continue: "繼續",
};

// TODO
const ms_MY = {
	// Modal buttons
	ok: "OK",
	cancel: "Batal",
	continue: "Teruskan",
};

// TODO
const de_DE = {
	// Modal buttons
	ok: "OK",
	cancel: "Abbrechen",
	continue: "Fortsetzen",
};

// TODO
const ru_RU = {
	// Modal buttons
	ok: "ОК",
	cancel: "Отмена",
	continue: "Продолжить",
};

// TODO
const es_ES = {
	// Modal buttons
	ok: "OK",
	cancel: "Cancelar",
	continue: "Continuar",
};

// TODO
const es_MX = {
	// Modal buttons
	ok: "ACEPTAR",
	cancel: "Cancelar",
	continue: "Continuar",
};

// TODO
const it_IT = {
	// Modal buttons
	ok: "OK",
	cancel: "Annulla",
	continue: "Continua",
};

// TODO
const ja_JP = {
	// Modal buttons
	ok: "オクラホマ州",
	cancel: "キャンセル",
	continue: "続ける",
};

// TODO
const ko_KR = {
	// Modal buttons
	ok: "확인",
	cancel: "취소",
	continue: "계속",
};

// TODO
const pt_BR = {
	// Modal buttons
	ok: "Ok",
	cancel: "Cancelar",
	continue: "Continuar",
};

// TODO
const th_TH = {
	// Modal buttons
	ok: "ตกลง",
	cancel: "ยกเลิก",
	continue: "ดำเนินการต่อ",
};

// TODO
const tr_TR = {
	// Modal buttons
	ok: "Tamam",
	cancel: "İptal",
	continue: "Devam et",
};

// TODO
const zh_HK = {
	// Modal buttons
	ok: "確定",
	cancel: "取消",
	continue: "繼續",
};

// TODO
const fr_FR = {
	// Modal buttons
	ok: "OK",
	cancel: "Annuler",
	continue: "Continuer",
};

const _ = en_US;

const i18n = {
	_,
	en_US,
	pt_PT,
	zh_TW,
	ms_MY,
	de_DE,
	ru_RU,
	es_ES,
	es_MX,
	it_IT,
	ja_JP,
	ko_KR,
	pt_BR,
	th_TH,
	tr_TR,
	zh_HK,
	fr_FR
};

export default i18n;